import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

import { DATE_FORMAT, TIME_FORMAT } from "shared/globals";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const defaultFormat = `${DATE_FORMAT} ${TIME_FORMAT} z`;

/**
 * Formats a date with a custom Day.js/Moment-compatible format string.
 * Falls back to the global default with timezone if a format string isn't provided.
 *
 * @example formatDate(date, "YY-MM-DD")
 *
 * @param {Date} date - JS data object.
 * @param {string?} format - Format string.
 */
export default function (date, format = defaultFormat) {
  return dayjs(date).format(format);
}

/**
 * Locale short-date formatter that never renders the literal "Invalid Date".
 * Returns `fallback` when the value is missing or cannot be parsed into a real
 * date, so UI that shows an "Updated {date}" style label degrades gracefully.
 *
 * @param {string|number|Date|null|undefined} value - Raw date value.
 * @param {*} [fallback] - Value to return when the date is absent/invalid.
 */
export function formatShortDate(value, fallback = undefined) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? fallback : d.toLocaleDateString();
}
